import React from "react";

import MiniDrawer from "../../components/Drawer"
import UsageComponent from "../../components/Settings/Usage";
import OptionsMenu from "../../utils/OptionsMenu";
import { getSession } from "../../auth";
import Channels from "../../components/Settings/Channels";
import Telegram from "../../components/Settings/Telegram";
import Instagram from "../../components/Settings/Instagram";
import Email from "../../components/Settings/Email";
import Sms from "../../components/Settings/Sms";
import MSTeams from "../../components/Settings/MSTeams";
import Messenger from "../../components/Settings/Messenger";
import userPermissions from "../../components/User/Permissions";

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';

import SmsIcon from '@mui/icons-material/Sms';
import SettingsPage from "../../components/Scout/Pages/settings-page";
import CellTowerIcon from "@mui/icons-material/CellTower";
import { SiMicrosoftteams } from "react-icons/si";

import ScoutLogo from "../../assets/images/kwik-scout-logo.png"
import { useMenu } from "../../contexts/MenuContext"

const getOptions = () => {
    const { configurableUrls } = useMenu()
    
    const enterprise = getSession()?.profile?.enterprise
    const groups = userPermissions();

    const platforms = enterprise?.platforms || []

    return {
        whatsapp: {
            permissions: groups.isAdmin,
            label: 'WhatsApp',
            component: (<Channels enterprise={enterprise}/>),
            icon: (<WhatsAppIcon className="whatsapp menu-icon"/>),
            
            isAvailable: platforms.whatsapp === true,
            unavailable: {
                icon: <WhatsAppIcon sx={{ color: '#34af23' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal WhatsApp, clique aqui.
                    </a>
                ),
            }
        },
        // usagewpp: {
        //     permissions: groups.isAdmin,
        //     label: 'Consumo',
        //     component: (<UsageComponent enterpriseId={enterprise?.id}/>),

        //     isAvailable: platforms.whatsapp === true,
        //     unavailable: {
        //         icon: <WhatsAppIcon sx={{ color: '#34af23' }} />,
        //         title: "Canal indisponível para sua conta.",
        //         description: (
        //             <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
        //                 Para contratar o canal WhatsApp, clique aqui.
        //             </a>
        //         ),
        //     }
        // },
        telegram: {
            permissions: groups.isAdmin,
            label: 'Telegram',
            component: (<Telegram enterprise={enterprise}/>),
            icon: (<TelegramIcon className="telegram menu-icon"/>),

            isAvailable: platforms.telegram === true,
            unavailable: {
                icon: <TelegramIcon sx={{ color: '#3390ec' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal Telegram, clique aqui.
                    </a>
                ),
            }
        },
        instagram: {
            permissions: groups.isAdmin,
            label: 'Instagram / Messenger',
            component: (<Instagram enterprise={enterprise}/>),
            icon: (<InstagramIcon className="menu-icon" sx={{ color: '#fd6b10' }}/>),

            isAvailable: (platforms.instagram === true || platforms.messenger === true),
            unavailable: {
                icon: <InstagramIcon sx={{ color: '#fd6b10' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal Instagram e/ou Messenger, clique aqui.
                    </a>
                ),
            }
        },
        scout: {
            permissions: groups.isAdmin,
            label: 'Scout',
            component: (<SettingsPage />),
            icon: (<CellTowerIcon className="menu-icon" sx={{ color: '#6264A7' }} />),

            isAvailable: platforms.scout === true && getSession().profile?.scout === true,
            unavailable: {
                icon: <img src={ScoutLogo} alt="Kwik Scout" style={{ width: 350 }} />,
                title: platforms.scout !== true
                    ? "Canal indisponível para sua conta."
                    : "Canal indisponível para seu usuário.",
                description: platforms.scout !== true
                    ? (
                        <a
                            href={configurableUrls?.scout ? configurableUrls.scout : "https://scout.kwik.app.br/"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Para mais informações sobre o Kwik Scout, clique aqui.
                        </a>
                    )
                    : (
                        <span>
                            Entre em contato com seu administrador para ativar.
                        </span>
                    )
            }
        },
        email: {
            permissions: groups.isAdmin,
            label: 'Email',
            component: (<Email enterprise={enterprise}/>),
            icon: (<EmailIcon className="menu-icon" sx={{ color: '#757575' }} />),

            isAvailable: platforms.email === true,
            unavailable: {
                icon: <EmailIcon sx={{ color: '#757575' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal E-mail, clique aqui.
                    </a>
                ),
            }
        },
        sms: {
            permissions: groups.isAdmin,
            label: 'Sms',
            component: (<Sms enterprise={enterprise}/>),
            icon: (<SmsIcon className="menu-icon" sx={{ color: '#757575' }} />),

            isAvailable: platforms.sms === true,
            unavailable: {
                icon: <SmsIcon sx={{ color: '#757575' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal SMS, clique aqui.
                    </a>
                ),
            }
        },
        msteams: {
            permissions: groups.isAdmin,
            label: 'Microsoft Teams',
            component: (<MSTeams enterprise={enterprise} />),
            icon: (<SiMicrosoftteams className="menu-icon" style={{ color: '#6264A7' }} />),

            isAvailable: platforms.msteams === true,
            unavailable: {
                icon: <SiMicrosoftteams style={{ color: '#6264A7' }} />,
                title: "Canal indisponível para sua conta.",
                description: (
                    <a href={configurableUrls?.agendamento ? configurableUrls.agendamento : "https://solucoes.instant.com.br/agendamento/"} target="_blank" rel="noopener noreferrer">
                        Para contratar o canal Microsoft Teams, clique aqui.
                    </a>
                ),
            }
        }
    }
}

const ChannelsPage = (socket) => {
    return (
        <MiniDrawer child={
            <OptionsMenu name='channels'
                options={getOptions} />
        } socket={socket.socket} />
    );
};

export default ChannelsPage;
